export default __webpack_public_path__ + "static/media/traveler-outside-train-1x.1e89ac5e.webp";